module.exports = __webpack_public_path__ + "media/stashboard/default_thumbnail_image-361354d3.png";